import { useEffect, useState } from 'react';
import { loadYasna } from './loadYasna';

/** { yasna, error } — yasna is the loaded embed module once ready. */
export default function useYasna() {
  const [state, setState] = useState({ yasna: null, error: null });
  useEffect(() => {
    let cancelled = false;
    loadYasna().then(
      (yasna) => { if (!cancelled) setState({ yasna, error: null }); },
      (e) => { if (!cancelled) setState({ yasna: null, error: e.message || String(e) }); }
    );
    return () => { cancelled = true; };
  }, []);
  return state;
}
